// FormDataContext.js
import { createContext, useContext, useState } from "react";

const FormDataContext = createContext();

export function FormDataProvider({ children }) {
  const [formData, setFormData] = useState({
    User: {},
    UserSettings: {}
  });

  // Seed initial values (e.g. UserID) without triggering "touched" logic
const initForm = (table, values) => {
  setFormData(prev => ({
    ...prev,
    [table]: {
      ...values,        // initial values go UNDER
      ...prev[table]    // existing user input stays ON TOP
    }
  }));
};

  // Update a specific table's fields
  const updateForm = (table, field, value) => {
    setFormData(prev => ({
      ...prev,
      [table]: {
        ...prev[table],
        [field]: value
      }
    }));
  };

  // Batch update multiple fields at once (optional)
  const updateFormBatch = (table, values) => {
    setFormData(prev => ({
      ...prev,
      [table]: {
        ...prev[table],
        ...values
      }
    }));
  };

  // Reset specific table or all forms
  const resetForm = (table) => {
    if (table) {
      setFormData(prev => ({ ...prev, [table]: {} }));
    } else {
      setFormData({ user: {}, userSettings: {} });
    }
  };

  return (
    <FormDataContext.Provider value={{ 
      formData, 
      updateForm, 
      updateFormBatch,
      initForm,
      resetForm 
    }}>
      {children}
    </FormDataContext.Provider>
  );
}

export const useFormData = () => useContext(FormDataContext);